import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconSunMedium",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, _, f, a) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--sun-medium"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Sun Medium",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.232 4.232a2.5 2.5 0 1 1 3.536 3.536 2.5 2.5 0 0 1-3.536-3.536ZM6 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM6 1a.5.5 0 0 1 .5.5V2a.5.5 0 0 1-1 0v-.5A.5.5 0 0 1 6 1Zm0 8.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0V10a.5.5 0 0 1 .5-.5ZM1 6a.5.5 0 0 1 .5-.5H2a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 1 6Zm8.5 0a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H10a.5.5 0 0 1-.5-.5Zm.036-3.536a.5.5 0 0 1 0 .708l-.354.353a.5.5 0 1 1-.707-.707l.353-.354a.5.5 0 0 1 .708 0ZM3.525 8.475a.5.5 0 0 1 0 .707l-.353.354a.5.5 0 1 1-.708-.708l.354-.353a.5.5 0 0 1 .707 0ZM2.464 2.464a.5.5 0 0 1 .708 0l.353.354a.5.5 0 1 1-.707.707l-.354-.353a.5.5 0 0 1 0-.708Zm6.011 6.011a.5.5 0 0 1 .707 0l.354.353a.5.5 0 1 1-.708.708l-.353-.354a.5.5 0 0 1 0-.707Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, c);
}
const v = /* @__PURE__ */ s(m, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=sun-medium.js.map
